import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-new-task',
    templateUrl: './new-task.component.html',
    styleUrls: ['./new-task.component.scss'],
    standalone: false ,  // NOSONAR
})
export class NewTaskComponent implements OnInit {

selectedRegions= [];
  constructor() { 

  }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}

}
